import React from 'react';

interface CatchByTime {
  year: number;
  month: number;
  totalCatches: number;
  taken: number;
  released: number;
  unknown: number;
}

export const ActivityHeatmap = ({data}: { data: CatchByTime[] }) => {
  if (!data || data.length === 0) {
    return (
      <div className="card h-100">
        <div className="card-header">
          <h3 className="card-title">Aktivitäts-Heatmap</h3>
        </div>
        <div className="card-body">
          <div className="text-muted">Keine Daten verfügbar</div>
        </div>
      </div>
    );
  }

  const monthNames = [
    'Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun',
    'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'
  ];

  const maxCatches = Math.max(...data.map(d => d.totalCatches));

  const getColorIntensity = (value: number) => {
    if (value === 0) return '#f3f4f6';
    const intensity = Math.min(value / maxCatches, 1);
    const green = Math.floor(255 - (intensity * 100));
    const blue = Math.floor(255 - (intensity * 130));
    return `rgb(59, ${green}, ${blue})`;
  };

  return (
    <div className="card h-100">
      <div className="card-header">
        <h3 className="card-title">Aktivitäts-Heatmap (Monatlich)</h3>
      </div>
      <div className="card-body">
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '10px'}}>
          {data.map((item) => (
            <div
              key={item.month}
              style={{
                backgroundColor: getColorIntensity(item.totalCatches),
                padding: '20px',
                borderRadius: '8px',
                textAlign: 'center',
                color: item.totalCatches > maxCatches * 0.5 ? '#fff' : '#000',
                fontWeight: 'bold',
                transition: 'transform 0.2s',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.05)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
              title={`${monthNames[item.month - 1]}: ${item.totalCatches} Fänge`}
            >
              <div style={{fontSize: '0.9rem'}}>{monthNames[item.month - 1]}</div>
              <div style={{fontSize: '1.5rem', marginTop: '5px'}}>{item.totalCatches}</div>
            </div>
          ))}
        </div>
        <div style={{marginTop: '20px', textAlign: 'center', fontSize: '0.85rem', color: '#6b7280'}}>
          Hellere Farben = weniger Fänge, Dunklere Farben = mehr Fänge
        </div>
      </div>
    </div>
  );
};
